import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
// eslint-disable-next-line @nrwl/nx/enforce-module-boundaries
import { BaseCRUDApiClient } from '@ideapa/app-base-api-client';
import { ProspettoDto, ResultDto } from '@ideapa/common-dto';

import { ApiClientConfig } from '../api-client-config';

@Injectable()
export class ProspettoApiClient extends BaseCRUDApiClient<ProspettoDto> {
  baseUrl = this.config.apiEndpoint + '/prospetto';

  constructor(http: HttpClient, private config: ApiClientConfig) {
    super(http);
  }

  importExcelFile(file: File, esercizio: number) {
    this._pagedCache.clear();
    const fd = new FormData();
    fd.append('file', file);
    return this.http.post<ResultDto>(
      this.baseUrl + '/import-excel/' + esercizio,
      fd
    );
  }
}
